function initialize() {
    $('.page-recipe-search-or-level select[name="order"]').on('change', function (evt) {
        window.location = '/receitas/' + $(this).data('slug') + '?order=' + $(this).val() + '#receitas';
    });
}

initialize();
